import TestSelect from 'view/pages/profile/TestPage/Select';
import { CandidateListItem, NoResultsBlock } from 'view/pages/candidates/components';
import { Spinner } from 'view/components';
import { Controller, useFormContext } from 'react-hook-form-mui';
import { CANDIDATES_ITEMS_PER_PAGE } from 'view/pages/candidates/hooks/useGetCandidates';
import * as CS from 'view/pages/candidates/commonStyled';
import * as S from './styled';

export const sortOptions = [
  { id: 1, name: 'Relevance score', value: 'relevance' },
  { id: 2, name: 'Experience level', value: 'yearsOfExperience' },
  { id: 3, name: 'Updated Date', value: 'updatedAt' },
];

const CandidatesListBlock = ({ isLoading, data, onSubmit, page, setPage, queryAfterSubmit }) => {
  const { control, handleSubmit } = useFormContext<any>();

  return (
    <S.CandidatesListBlock>
      <S.CandidatesListBlockHeader>
        <S.CandidatesListBlockTitle>{data?.total || 0} candidates</S.CandidatesListBlockTitle>
        <S.CandidatesListBlockSortBy>
          <p>Sort by:</p>
          <Controller
            name="sort"
            control={control}
            render={({ field }) => {
              return (
                <TestSelect
                  {...field}
                  label=""
                  options={sortOptions || []}
                  selectedValue={field.value}
                  onChange={(selected) => {
                    field.onChange(selected); // Сначала обновляем значение
                    setTimeout(() => {
                      return handleSubmit(onSubmit(page))();
                    }, 0); // Сабмитим после обновления
                  }}
                  marginbottom={0.1}
                  disabled={!sortOptions}
                />
              );
            }}
          />
        </S.CandidatesListBlockSortBy>
      </S.CandidatesListBlockHeader>
      {isLoading && (
        <Spinner
          variant="outlined"
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            backgroundColor: 'rgba(217, 225, 255, 0.3)',
            width: '100%',
            height: '100%',
            zIndex: 10,
          }}
        />
      )}
      {!isLoading && !data?.total && (
        <NoResultsBlock
          title="Unfortunately, there are no results"
          subTitle={'Please try other variations of the search, \n or reset filters.'}
        />
      )}
      {data?.total && !!data?.data?.length ? (
        <>
          <S.CandidatesListBlockMainWrapper>
            <>
              {data?.data?.map((item) => {
                return (
                  <CandidateListItem
                    candidate={item}
                    key={item.id}
                    queryAfterSubmit={queryAfterSubmit}
                    successFunction={() => {
                      handleSubmit(onSubmit(page))();
                    }}
                  />
                );
              })}
            </>
          </S.CandidatesListBlockMainWrapper>
          <CS.CustomPagination
            count={Math.ceil(data.total / CANDIDATES_ITEMS_PER_PAGE)}
            shape="rounded"
            page={page}
            onChange={(e, page) => {
              setPage(page);
              setTimeout(() => {
                handleSubmit(onSubmit(page))();
              }, 0);
            }}
            style={{ margin: 'auto auto 0' }}
          />
        </>
      ) : null}
    </S.CandidatesListBlock>
  );
};

export default CandidatesListBlock;
